import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';
import getMyPermission from './getMyPermission';

const getMyProfile = createAsyncThunk('profile/getMyProfile',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const { data: user } = await authGet('/me');
      dispatch(getMyPermission(user.role.id));
      return user;
    } catch (error) {
      const { data: { message } } = error;
      return rejectWithValue(message);
    }
  });

export default getMyProfile;
